(function(){
  'use strict';
  document.querySelectorAll('[data-trisoria-language]').forEach(function(select){
    select.addEventListener('change',function(){
      var selected=select.options[select.selectedIndex];
      if(!selected||selected.disabled)return;
      var form=select.closest('form');
      if(!form)return;
      if(typeof form.requestSubmit==='function')form.requestSubmit();
      else form.submit();
    });
  });
})();
